<div class="position-relative" #libraryviewmode>
  <div class="row {{ tooltipText ? '' : 'mb-2' }}">
    <ng-container *ngIf="backAndBreadCrumHide">
      <div class="w-100 mb-2 mt-3" *ngIf="breadcrumbItems?.length > 0 && defaultOpen !== 'images' && !mobToggle">
        <app-breadcrumbs
          [privateOffice]="propertyId?.length == 0 ? true : false"
          [directorylocation]="category"
          (breadCrumbId)="getBreadId($event)"
          [data]="breadcrumbItems">
        </app-breadcrumbs>
      </div>
    </ng-container>
    <div class="progress-bar" *ngIf="progress > 0 && progress < 100">
      <div class="progress-fill" [style.width.%]="progress">{{ progress }}%</div>
    </div>
    <div
      class="{{ mobToggle ? 'd-block' : 'd-flex' }} align-items-center justify-content-end"
      [ngClass]="propertyId?.length > 0 ? 'col-md-12 middle-screen-fixup' : 'col-md-12'">
      <div class="mr-auto d-flex align-items-center">
        <ng-container *ngIf="backAndBreadCrumHide">
          <a
            class="d-flex align-items-center text-dark f-14 font-weight-bold pr-3"
            href="javascript:void(0);"
            (click)="selectFolders(breadcrumbItems[breadcrumbItems?.length - 2]?.url, false)"
            *ngIf="propertyId?.length > 0 && breadcrumbItems?.length > backBtnValue && isBackBtnShown">
            <i class="fa fa-arrow-left mr-2"></i>Back
          </a>
          <a
            class="d-flex align-items-center text-dark f-14 font-weight-bold pr-3"
            href="javascript:void(0);"
            (click)="selectFolders(breadcrumbItems[breadcrumbItems?.length - 2]?.url)"
            *ngIf="propertyId?.length == 0 && breadcrumbItems?.length > backBtnValue && isBackBtnShown">
            <i class="fa fa-arrow-left mr-2"></i>Back
          </a>
        </ng-container>
        <div class="search-folder mb-3 {{ mobToggle ? 'mr-0' : 'mr-3' }}">
          <div class="w-100 cs-mx-h-55">
            <i class="pi pi-search cp private-search" style="color: #76828f"></i>
            <input
              type="text"
              [(ngModel)]="searchKeyword"
              (input)="search($event?.target?.['value'])"
              placeholder="Search"
              style="padding-left: 30px" />
            <i (click)="search(null); searchKeyword = ''" class="pi pi-times cp cancel-search" *ngIf="searchKeyword"></i>
          </div>
        </div>
        <div class="row align-items-center justify-content-between {{ mobToggle ? 'd-none' : '' }}">
          <div class="mt-2 task-switch-wrap" *ngIf="userPermission.includes('reorder_images.view') || userRole == 'master admin'">
            <label *ngIf="getFilteredFolderFileIfShared(libraryData)?.length > 0" class="mr-1 f-12"
              >{{ getFilteredFolderFileIfShared(libraryData)?.length }}
              {{ getFilteredFolderFileIfShared(libraryData)?.length > 1 ? 'Files' : 'File' }}</label
            >
          </div>
        </div>
      </div>
      <div class="position-relative my-auto mr-2" *ngIf="category == 'workspace'">
        <label for="hiddenworkspace" class="font-weight-400 f-14">
          Hidden Workspace
          <p-checkbox
            name="hiddenworkspace"
            [(ngModel)]="isHiddenWorkspaceVisible"
            (onChange)="onChangeWorkspaceHidden()"
            [binary]="true"
            inputId="hiddenworkspace"></p-checkbox>
        </label>
      </div>
      <div *ngIf="hidePropertyLibrary">
        <app-library-menu
          [hidePropertyLibrary]="hidePropertyLibrary"
          [librarydata]="libraryDataEmitter"
          [propertyId]="propertyId"
          [contract_Id]="contract_Id"
          [isContractLibrary]="isContractLibrary"></app-library-menu>
      </div>

      <div class="d-flex align-items-center mt-3" *ngIf="mobToggle">
        <ng-container *ngIf="!noShowListingButton && (propertyId || contract_Id)">
          <img
            [src]="images?.link_icon"
            tooltipPosition="bottom"
            pTooltip="Add Link"
            alt=""
            class="ml-2 cursor-pointer"
            (click)="viewDialog = !viewDialog"
            *ngIf="backAndBreadCrumHide" />
        </ng-container>
        <ng-container *ngIf="page_title != 'My Workspace'">
          <ng-container *ngIf="libraryData?.length > 0 && libraryData[0]?.ispermission == true">
            <img
              [src]="images?.edit_icon"
              tooltipPosition="bottom"
              pTooltip="Edit"
              (click)="showLibedit(true); lmService.showIcons = false"
              class="{{ mobToggle || is_project ? 'd-none' : '' }} ml-2 cursor-pointer pencil-icon" />
            <div class="layout-changer overlay-background d-flex ml-auto">
              <ng-container *ngIf="userRole?.toLowerCase() !== 'contacts'">
                <a href="javascript:void(0);" (click)="GridView = false" [ngClass]="{ active: !GridView }" class="list-view">
                  <img [src]="common_images?.list_view" tooltipPosition="bottom" pTooltip="List" [ngClass]="!GridView ? 'svg-active' : 'svg-image'" />
                </a>
              </ng-container>
              <a href="javascript:void(0);" (click)="GridView = true" [ngClass]="{ active: GridView }" class="grid-view ml-2">
                <img
                  [src]="common_images?.grid_view_v2"
                  tooltipPosition="bottom"
                  pTooltip="Grid"
                  [ngClass]="GridView ? 'svg-active' : 'grid-svg-image'" />
              </a>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container *ngIf="!noShowListingButton && (propertyId || contract_Id) && !mobToggle">
        <img
          [src]="images?.link_icon"
          tooltipPosition="bottom"
          pTooltip="Add Link"
          alt=""
          class="ml-2 cursor-pointer"
          (click)="viewDialog = !viewDialog" />
      </ng-container>
      <ng-container *ngIf="page_title != 'My Workspace'">
        <ng-container *ngIf="libraryData?.length > 0 && libraryData[0]?.ispermission == true && !mobToggle">
          <div class="pencil-icon ml-2">
            <img
              [src]="common_images?.library_edit_icon"
              tooltipPosition="top"
              pTooltip="Reorder"
              (click)="showLibedit(true); lmService.showIcons = false"
              class="cursor-pointer" />
          </div>
          <div class="layout-changer overlay-background d-flex ml-2">
            <ng-container *ngIf="userRole?.toLowerCase() !== 'contacts'">
              <a href="javascript:void(0);" (click)="GridView = false" [ngClass]="{ active: !GridView }" class="list-view">
                <img [src]="common_images?.list_view" tooltipPosition="bottom" pTooltip="List" [ngClass]="!GridView ? 'svg-active' : 'svg-image'" />
              </a>
            </ng-container>
            <a href="javascript:void(0);" (click)="GridView = true" [ngClass]="{ active: GridView }" class="grid-view ml-2">
              <img
                [src]="common_images?.grid_view_v2"
                tooltipPosition="bottom"
                pTooltip="Grid"
                [ngClass]="GridView ? 'svg-active' : 'grid-svg-image'" />
            </a>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <p class="primary-color mb-2" *ngIf="tooltipText">{{ tooltipText }}</p>
    <div class="flexCenterEnd pr-0 mb-2 mt-1" *ngIf="selectedItems?.length">
      <img
        [src]="common_images?.delete_icon"
        alt="delete"
        class="mr-2 cursor-pointer"
        width="16px"
        (click)="emptyTrash()"
        *ngIf="page_title == 'Trash Files' && TrashlibraryData?.length" />
      <ng-container>
        <button
          *ngIf="selectItem?.type != 'folder' && parentComp && isContractLibrary == false"
          href="javascript:void(0)"
          class="{{ mobToggle ? 'd-none' : '' }} preview-btn mr-3 cursor-pointer"
          (click)="useThisInParent(selectedItems)">
          Use Selected File
        </button>
        <i
          tooltipPosition="bottom"
          pTooltip="Get Link"
          *ngIf="selectItem?.type != 'folder'"
          class="mr-3 f-14"
          (click)="showModalGetLink(selectItem)"></i>
        <ng-container *ngIf="checkPermission()">
          <i
            tooltipPosition="bottom"
            tooltipPosition="bottom"
            pTooltip="Share"
            *ngIf="page_title != 'My Workspace' && category != 'trash'"
            class="mr-3 pi pi-user-plus cursor-pointer f-14"
            (click)="checkFileAccess(selectItem, 'share')"></i>
          <img
            tooltipPosition="bottom"
            tooltipPosition="bottom"
            pTooltip="Remove"
            *ngIf="selectedItems?.length > 1 && category != 'trash'"
            [src]="common_images?.delete_icon"
            class="mr-3 cursor-pointer"
            width="14px"
            (click)="checkFileAccess(selectItem, 'remove')" />
          <img
            tooltipPosition="bottom"
            pTooltip="Remove"
            *ngIf="selectedItems?.length < 2 && category != 'trash'"
            [src]="common_images?.delete_icon"
            alt="Remove"
            class="mr-3 cursor-pointer"
            width="14px"
            (click)="checkFileAccess(selectItem, 'remove')" />
          <i
            tooltipPosition="bottom"
            pTooltip="Download"
            *ngIf="selectedItems?.length > 0"
            class="mr-3 pi pi-download cursor-pointer f-14"
            (click)="pendingAction = 'download'; downloadMultiple(selectedItems)"></i>
          <div class="position-relative" [ngClass]="propertyId?.length > 0 ? 'globalOptionsProperty' : 'globalOptions'">
            <i
              tooltipPosition="bottom"
              pTooltip="More Actions"
              class="mr-3 pi pi-ellipsis-v cursor-pointer f-14"
              (click)="globalOptions.show($event); filesOptions.hide()"></i>
            <p-overlayPanel #globalOptions>
              <ng-template pTemplate>
                <div class="body-details border-0 p-0 bg-white">
                  <ul class="folders">
                    <li *ngIf="page_title != 'Trash Files' && selectItem?.type != 'folder'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'preview')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-eye f-12 text-dark mr-3"></i> Preview
                      </a>
                    </li>
                    <li *ngIf="page_title != 'Trash Files' && selectItem?.type != 'folder'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'link')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-link f-12 text-dark mr-3"></i> Get Link
                      </a>
                    </li>
                    <li *ngIf="page_title != 'Trash Files' && selectItem?.type != 'folder'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'path')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-directions f-12 text-dark mr-3"></i> Get Path
                      </a>
                    </li>
                    <li *ngIf="page_title != 'My Workspace' && page_title != 'Trash Files' && category != 'useroffice' && category !== 'favourite'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'move-to-folder')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-cloud-upload f-12 text-dark mr-3"></i> Move to
                      </a>
                    </li>
                    <li
                      *ngIf="
                        library_type != 'office' &&
                        page_title != 'Trash Files' &&
                        category == 'folder' &&
                        page_title != 'My Workspace' &&
                        selectItem?.type != 'folder'
                      ">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'workspace')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <img [src]="images?.brief_case_icon" alt="Rename" class="mr-3" width="13px" height="12px" /> Add to Workspace
                      </a>
                    </li>
                    <li *ngIf="page_title != 'Trash Files'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'rename')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <div class="iconStyle">
                          <img [src]="common_images?.edit_icon" style="height: 13px" class="f-12 text-dark mr-3" />
                        </div>
                        Rename
                      </a>
                    </li>
                    <li *ngIf="page_title != 'My Workspace' && page_title != 'Trash Files'">
                      <a
                        (click)="globalOptions.hide(); checkFileAccess(selectItem, 'copy')"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-copy f-12 text-dark mr-3"></i> Make a Copy
                      </a>
                    </li>
                    <li *ngIf="page_title != 'Trash Files' && selectItem?.type != 'folder'">
                      <a
                        (click)="globalOptions.hide(); downloadMultiple(selectItem); pendingAction = 'download'"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-download f-12 text-dark mr-3"></i> Download
                      </a>
                    </li>
                    <li *ngIf="page_title == 'My Workspace' && selectItem?.type == 'folder'">
                      <a
                        (click)="globalOptions.hide(); hideShowWorkspace(selectItem?._id)"
                        href="javascript:void(0)"
                        class="d-flex align-items-center f-14 text-dark px-2 py-2">
                        <i class="pi pi-exclamation-triangle f-12 text-dark mr-3"></i> Hide Workspace
                      </a>
                    </li>
                    <div *ngIf="page_title == 'Trash Files'">
                      <li>
                        <a
                          (click)="filesOptions.hide(); contextMenuHandler($event, 'restore')"
                          (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'restore')"
                          href="javascript:void(0)"
                          class="d-flex align-items-center f-14 text-dark px-2 py-2">
                          <i class="pi pi-replay f-12 text-dark mr-3"></i> Restore
                        </a>
                      </li>
                      <li>
                        <a
                          (click)="filesOptions.hide(); contextMenuHandler($event, 'delete-forever')"
                          (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'delete-forever')"
                          href="javascript:void(0)"
                          class="d-flex align-items-center f-14 text-dark px-2 py-2">
                          <img [src]="common_images?.delete_icon" alt="Remove" class="mr-3" width="13px" /> Delete forever
                        </a>
                      </li>
                    </div>
                  </ul>
                </div>
              </ng-template>
            </p-overlayPanel>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Start Body -->
  <div class="designs-body mt-2 ml-2">
    <section id="recent-file-for-workspace" *ngIf="page_title == 'My Workspace' && workspaceRecentFiles?.length > 0">
      <div class="library-files-wrap">
        <p-carousel
          [value]="workspaceRecentFiles"
          [numVisible]="5"
          [numScroll]="5"
          [circular]="false"
          [showIndicators]="false"
          [responsiveOptions]="responsiveOptions">
          <ng-template let-recentfiles pTemplate="item">
            <div
              class="product-item my-5"
              (contextmenu)="filesOptions.show($event); rightClickHandler($event, recentfiles?.file, true)"
              (dblclick)="recentfiles?.file?.type == 'file' && checkPublicPrivate(recentfiles?.file)">
              <div
                [id]="recentfiles?._id"
                class="lib-file position-relative product-item-content"
                [ngClass]="
                  recentfiles?.file?.type === 'folder' || recentfiles?.file?.files_or_folders
                    ? 'folder-file flex-wrap position-relative'
                    : 'image-file'
                "
                pTooltip="{{ getFolderFileInformationTooltipHandler(recentfiles) }}"
                [tooltipDisabled]="isTooltipDisabled"
                [escape]="false"
                tooltipPosition="bottom">
                <!-- Default Folder Image -->
                <img *ngIf="recentfiles?.file?.type === 'folder'" [id]="recentfiles?._id" [src]="images?.lib_folder_icon" class="file-image" />
                <!-- Image -->
                <div
                  [id]="recentfiles?._id"
                  *ngIf="
                    (recentfiles?.file?.type !== 'folder' && recentfiles?.file?.file_type === 'image/jpeg') ||
                      recentfiles?.file?.file_type === 'image/png' ||
                      recentfiles?.file?.file_type === 'image/jpeg';
                    else otherIcons
                  ">
                  <div class="lib-office-name">M</div>
                  <img [src]="getCompressImageByPath(recentfiles?.file)" (error)="LoadImageonError($event, recentfiles?.file)" class="file-image" />
                </div>
                <!-- Other's -->
                <ng-template #otherIcons>
                  <div [id]="recentfiles?._id" class="file-image centered" *ngIf="recentfiles?.file?.type !== 'folder'">
                    <img [src]="libHelper.fileThumbbyName(recentfiles?.file)" width="100" />
                  </div>
                </ng-template>
                <div
                  class="px-3 pb-2 lib-file-content d-flex w-100"
                  [ngClass]="recentfiles?.file?.type == 'folder' ? 'justify-content-center mt-auto' : 'justify-content-between'">
                  <h4 [id]="recentfiles?._id" class="text-ellipsis" [ngClass]="{ 'text-center': recentfiles?.file?.type === 'folder' }">
                    {{ recentfiles?.file?.name }}
                  </h4>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </section>
    <div *ngIf="page_title == 'Trash Files'">
      <h4>
        {{ propertyId?.length > 0 ? SearchedResultName : page_title }}
        <p>
          <small class="text-dark py-1"> Files will be permanently deleted after 7 days. </small>
        </p>
      </h4>
    </div>

    <p-dialog
      [(visible)]="viewDialog"
      [dismissableMask]="true"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '600px', margin: 'auto 0' }">
      <ng-template pTemplate="header"> Listing Links </ng-template>
      <div class="modalGetLink">
        <div class="mt-3">
          <label>Video URL</label>
          <div class="position-relative">
            <input type="text" [(ngModel)]="embedVideoURL" placeholder="Add link" />
            <i class="pi pi-times _cross-icon" *ngIf="embedVideoURL?.length > 0" (click)="embedVideoURL = ''"></i>
          </div>
        </div>
        <div class="mt-2">
          <label>Online Tour 1</label>
          <div class="position-relative">
            <input type="text" [(ngModel)]="onlineTour1" placeholder="Add link" />
            <i class="pi pi-times _cross-icon" *ngIf="onlineTour1?.length > 0" (click)="onlineTour1 = ''"></i>
          </div>
        </div>
        <div class="mt-2">
          <label>Online Tour 2</label>
          <div class="position-relative">
            <input type="text" [(ngModel)]="onlineTour2" placeholder="Add link" />
            <i class="pi pi-times _cross-icon" *ngIf="onlineTour2?.length > 0" (click)="onlineTour2 = ''"></i>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button type="button" class="_cancel-btn mr-3" (click)="viewDialog = !viewDialog">Cancel</button>
          <button type="button" class="_primary-btn mr-0" (click)="viewDialog = !viewDialog; addEmbeddedUrlVideo()">Save</button>
        </div>
      </div>
    </p-dialog>
    <section class="position-relative" [class.loading-background]="loading" *ngIf="libraryData?.length; else notfound">
      <div [class.spinner-drag-loader]="dragLoading" *ngIf="dragLoading">
        <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      </div>
      <!-- Grid View -->
      <div class="library-files-wrap" #libraryfilewrap *ngIf="GridView">
        <div *ngIf="isLoad">
          <div
            id="drag-n-drop-main"
            class="row"
            [draggable]="isDragable"
            (dragleave)="onDragLeave($event, null)"
            (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, null)"
            (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, null)"
            (dragend)="onDragEnd()"
            (drop)="onDrop($event, null)"
            cdkDropListGroup>
            <ng-container *ngFor="let item of libraryData; trackBy: trackById | searchFilter: searchKeyword; let i = index">
              <ng-container *ngIf="isAgentOrAdmin(item)">
                <div
                  class="form-group thumb-size the-dropList-item flex"
                  cdkDropList
                  [cdkDropListData]="{ itm: item, index: i }"
                  cdkDragBoundary=".library-files-wrap"
                  (cdkDropListDropped)="dropFolderFile($event)"
                  [cdkDragDisable]="hoverDisable"
                  *ngIf="category === 'trash' ? isFolderSharedWithUser(item) : isFolderSharedWithUser(item) && !item?.is_offline"
                  [class.selected]="isItemSelected(selectedItems, selectItem, item)"
                  style="display: flex; column-gap: 15px; padding-left: 6px; padding-right: 6px">
                  <img [src]="images?.tick_icon" class="selected-tick" *ngIf="isItemSelected(selectedItems, selectItem, item)" />
                  <div
                    [id]="item?._id"
                    class="lib-file position-relative"
                    cdkDrag
                    [ngClass]="[
                      propertyId?.length > 0 ? 'h-6rem' : '',
                      item?.type === 'folder' || item?.files_or_folders
                        ? page_title == 'My Workspace'
                          ? 'py-3 flex-wrap position-relative'
                          : 'folder-file flex-wrap position-relative'
                        : 'image-file',
                    ]"
                    (click)="page_title != 'My Workspace' && _selectItem($event, item)"
                    (dblclick)="
                      page_title != 'My Workspace' && category != 'trash' && item?.type === 'folder'
                        ? selectFolders(item, false)
                        : checkPublicPrivate(item)
                    "
                    (contextmenu)="
                      page_title != 'My Workspace' && filesOptions.show($event); page_title != 'My Workspace' && rightClickHandler($event, item)
                    "
                    pTooltip="{{ getFolderFileInformationTooltipHandler(item) }}"
                    [tooltipDisabled]="isTooltipDisabled"
                    [escape]="false"
                    tooltipPosition="bottom"
                    *ngIf="category === 'trash' || !item?.is_offline">
                    <div *cdkDragPreview style="opacity: 0.5">
                      <div class="gal-thumb-box1">
                        <a class="hwfix" href="javascript:void(0)">
                          <div class="img-hub-center" [style]="{ width: '162px', height: '140px' }">
                            <div class="thumb-bg">
                              <ng-container *ngIf="item?.type === 'folder'">
                                <img
                                  [id]="item?._id"
                                  *ngIf="item?.childrens?.length == 0"
                                  [src]="images?.lib_folder_icon"
                                  style="padding: 40px"
                                  [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                                  class="img-hub2" />
                                <img
                                  [id]="item?._id"
                                  *ngIf="item?.childrens?.length > 0"
                                  [src]="images?.lib_filled_folder_icon"
                                  [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                                  class="img-hub2"
                                  style="padding: 40px" />
                              </ng-container>
                              <ng-container *ngIf="item?.type !== 'folder'">
                                <img [src]="getCompressImageByPath(item)" class="img-hub2" (error)="LoadImageonError($event, item)" />
                              </ng-container>
                            </div>
                          </div>
                        </a>
                      </div>
                      <p
                        [id]="item?._id"
                        class="mt-3 black-text pb-1"
                        (mouseenter)="onEnter($event)"
                        (mouseleave)="onLeave($event)"
                        (click)="page_title == 'My Workspace' && openWorkspaceModal(item)"
                        [ngClass]="{ 'w-75': page_title == 'My Workspace', 'f-12': propertyId?.length > 0 }">
                        {{ item?.name }}
                      </p>
                    </div>
                    <div *ngIf="item?.type === 'folder' && page_title != 'My Workspace'">
                      <div
                        class="lib-office-name w-auto p-1 rounded bg-primary"
                        [ngClass]="{ 'font-size-property-listing h-1rem p-1': propertyId?.length > 0 }"
                        *ngIf="category == 'useroffice' && item?.view_only_with?.length > 0">
                        <!-- Shared -->
                        <i class="fa fa-users f-12 p-1" aria-hidden="true"></i>
                      </div>
                      <img
                        [id]="item?._id"
                        *ngIf="item?.childrens?.length == 0"
                        [src]="images?.lib_folder_icon"
                        [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                        class="file-image" />
                      <img
                        [id]="item?._id"
                        *ngIf="item?.childrens?.length > 0"
                        [src]="images?.lib_filled_folder_icon"
                        [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                        class="file-image" />

                      <p
                        [id]="item?._id"
                        class="folder_text mt-2 w-100 black-text"
                        (mouseenter)="onEnter($event)"
                        (mouseleave)="onLeave($event)"
                        (click)="page_title == 'My Workspace' && openWorkspaceModal(item)"
                        [ngClass]="{ 'w-75': page_title == 'My Workspace', 'f-12': propertyId?.length > 0 }">
                        {{ item?.name }}
                      </p>
                    </div>
                    <div
                      [id]="item?._id"
                      *ngIf="
                        item?.type !== 'folder' &&
                          (item?.type === 'matrix' ||
                            item?.type === 'reports' ||
                            item?.file_type === 'image/jpeg' ||
                            item?.file_type === 'image/png' ||
                            item?.file_type === 'image/jpeg' ||
                            item?.file_type?.includes('pdf'));
                        else otherIcons
                      ">
                      <ng-container *ngIf="item?.file_type?.includes('pdf'); else no_pdf">
                        <div class="gal-thumb-box1">
                          <a class="hwfix" href="javascript:void(0)">
                            <div class="img-hub-center" [style]="{ width: '162px', height: '140px' }">
                              <div class="file-image centered">
                                <img [src]="libHelper?.fileThumbbyName(item)" class="img-fluid" [width]="propertyId?.length > 0 ? 74 : 100" />
                              </div>
                            </div>
                          </a>
                        </div>
                        <p class="mt-3 black-text" (mouseenter)="onEnter($event)" (mouseleave)="onLeave($event)">
                          {{ item?.name?.slice(0, -4) }}
                        </p>
                      </ng-container>
                      <ng-template #no_pdf>
                        <div class="gal-thumb-box1">
                          <a class="hwfix" href="javascript:void(0)">
                            <div class="img-hub-center" [style]="{ width: '162px', height: '140px' }">
                              <div class="thumb-bg position-relative">
                                <img
                                  [src]="images?.lib_file_image"
                                  class="img-hub2"
                                  *ngIf="item?.type === 'matrix'"
                                  (error)="LoadImageonError($event, item)" />
                                <img
                                  [src]="images?.lib_report_icon"
                                  class="img-hub2"
                                  *ngIf="item?.type === 'reports'"
                                  (error)="LoadImageonError($event, item)" />
                                <img
                                  [src]="getCompressImageByPath(item)"
                                  class="img-hub2"
                                  *ngIf="item?.type !== 'matrix' || item?.type !== 'reports'"
                                  (error)="LoadImageonError($event, item)" />
                                <!-- <div class="img-hub-slider-overlay"
                                  *ngIf="(item?.type !== 'matrix' || item?.type !== 'reports') && !item?.slider_images?.length">
                                  <img [src]="LoadImageonError($event, item)" class="img-hub2 img-thumb-slider"
                                    (error)="LoadImageonError($event, item)" />
                                </div> -->
                                <img [src]="common_images?.lock_icon" class="private-icon" *ngIf="item?.private_file_access" />
                              </div>
                            </div>
                          </a>
                        </div>
                        <p
                          [id]="item?._id"
                          class="mt-3 black-text pb-1 f-12"
                          (mouseenter)="onEnter($event)"
                          (mouseleave)="onLeave($event)"
                          (click)="page_title == 'My Workspace' && openWorkspaceModal(item)"
                          [ngClass]="{ 'w-75': page_title == 'My Workspace', 'f-12': propertyId?.length > 0 }">
                          {{ item?.name }}
                        </p>
                      </ng-template>
                    </div>
                    <ng-template #otherIcons>
                      <div
                        [id]="item?._id"
                        class="file-image centered"
                        *ngIf="item?.type !== 'folder' && !item?.files_or_folders"
                        [ngClass]="{ 'h-100': propertyId?.length > 0 }">
                        <img [src]="libHelper?.fileThumbbyName(item)" class="mt-1 img-fluid" [width]="propertyId?.length > 0 ? 74 : 100" />
                      </div>
                      <!-- Same guard as the thumbnail above. A folder reaches this fallback (it has no
                           image type), and without the guard it was drawn no icon but still a name —
                           on top of the name its own tile already prints underneath it. -->
                      <p class="mt-1" *ngIf="item?.type !== 'folder' && !item?.files_or_folders">{{ item?.name }}</p>
                    </ng-template>
                    <div *ngIf="page_title == 'My Workspace'">
                      <div class="content-container py-2">
                        <ng-scrollbar class="vertical-scrollbar p-0" track="vertical" visibility="hover" appearance="compact">
                          <ng-container *ngFor="let child of item?.files_or_folders; trackBy: trackById">
                            <div
                              (dblclick)="child?.type === 'folder' ? selectFolders(child) : showModalPreview(child)"
                              class="d-flex w-100 justify-content-between p-3 hover-workspace-menu-items">
                              <div class="w-80">
                                <div class="d-flex">
                                  <div>
                                    <img
                                      *ngIf="child?.type === 'file'"
                                      [src]="libHelper.fileThumbbyName(child)"
                                      class="mt-1 img-fluid mr-2"
                                      width="40" />
                                    <img
                                      *ngIf="child.type === 'folder' && child?.childrens?.length === 0"
                                      [src]="images?.lib_folder_icon"
                                      class="mr-2"
                                      width="40"
                                      height="40" />
                                    <img
                                      *ngIf="child.type === 'folder' && child?.childrens?.length > 0"
                                      [src]="images?.lib_filled_folder_icon"
                                      class="mr-2"
                                      width="40"
                                      height="40" />
                                  </div>
                                  <div class="w-80">
                                    <h4 class="text-ellipsis">{{ child?.name }}</h4>
                                    <p>
                                      <small>Last Modified: {{ child?.updated_at | date: 'dd MMM yyyy' }}</small>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <button
                                pButton
                                pRipple
                                type="button"
                                icon="pi pi-ellipsis-v"
                                (click)="filesOptions.show($event); rightClickHandler($event, child)"
                                (contextmenu)="filesOptions.show($event); rightClickHandler($event, child)"
                                class="p-button-rounded p-button-secondary p-button-text invisible"
                                tooltipPosition="bottom"
                                pTooltip="Actions"
                                tooltipStyleClass="tooltip-secondary"></button>
                            </div>
                          </ng-container>
                        </ng-scrollbar>
                      </div>
                      <div class="mt-auto" (mouseenter)="onEnter($event)" (mouseleave)="onLeave($event)">
                        <button pButton pRipple type="button" label="{{ item?.name }}" (click)="openWorkspaceModal(item)" class="view-files"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- List View -->
      <div class="library-files-listview" #libraryfilewrap *ngIf="!GridView">
        <ng-container>
          <p-table [value]="libraryData" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name" style="width: 190px; padding-left: 5px !important; font-size: 12px; font-weight: 500 !important">
                  <div class="pl-0 d-flex align-items-center">Name<p-sortIcon field="name" style="padding-left: 5px"></p-sortIcon></div>
                </th>
                <th
                  pSortableColumn="updated_at"
                  style="width: 130px; padding-left: 5px !important; font-size: 12px; font-weight: 500 !important"
                  class="f-12 _fw-500">
                  <div class="d-flex align-items-center">Last Modified <p-sortIcon field="updated_at" style="padding-left: 5px"></p-sortIcon></div>
                </th>
                <th
                  pSortableColumn="readable_file_size"
                  style="width: 130px; padding-left: 5px !important; font-size: 12px; font-weight: 500 !important"
                  class="f-12 _fw-500">
                  <div class="d-flex align-items-center">File Size<p-sortIcon field="readable_file_size" style="padding-left: 5px"></p-sortIcon></div>
                </th>
                <th
                  pSortableColumn="created_at"
                  style="width: 130px; padding-left: 5px !important; font-size: 12px; font-weight: 500 !important"
                  class="f-12 _fw-500">
                  <div class="d-flex align-items-center">Date Added<p-sortIcon field="created_at" style="padding-left: 5px"></p-sortIcon></div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr
                ngSortgridItem
                [ngSortGridItems]="getFilteredFolderFileIfShared(libraryData)"
                (sorted)="updateFolderStructureSequences($event)"
                (dblclick)="category == 'workspace' && item.type === 'folder' ? selectFolders(item) : showModalPreview(item)"
                (click)="
                  category != 'workspace' && category != 'trash' && item.type === 'folder' ? selectFolders(item) : _selectItem($event, item);
                  isDragDropSorting = !isDragDropSorting
                "
                [class.selected]="selectedItems[i]?._id == item._id || selectItem?._id == item._id"
                class="drag-container position-relative"
                (contextmenu)="page_title != 'My Workspace' && filesOptions.show($event); $event.preventDefault(); rightClickHandler($event, item)"
                *ngIf="isFolderSharedWithUser(item) && !item?.is_offline">
                <td
                  style="padding-left: 4px !important"
                  [id]="item?._id"
                  draggable="false"
                  (dragleave)="onDragLeave($event, item)"
                  (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, item)"
                  (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, item)"
                  (dragend)="onDragEnd()"
                  (drop)="onDrop($event, item)"
                  class="pl-0 text-truncate"
                  pTooltip="{{ getFolderFileInformationTooltipHandler(item) }}"
                  [tooltipDisabled]="isTooltipDisabled"
                  [escape]="false"
                  tooltipPosition="bottom">
                  <img *ngIf="item.type === 'folder' && item?.childrens.length == 0" [src]="images?.lib_folder_icon" class="mr-2" width="20" />
                  <img *ngIf="item.type === 'folder' && item?.childrens.length > 0" [src]="images?.lib_filled_folder_icon" class="mr-2" width="20" />
                  <img
                    *ngIf="
                      (item?.type !== 'folder' && item?.file_type === 'image/jpeg') ||
                        item?.file_type === 'image/png' ||
                        item?.file_type === 'image/jpeg';
                      else otherIcons
                    "
                    [src]="getCompressImageByPath(item)"
                    (error)="LoadImageonError($event, item)"
                    class="mr-2"
                    width="20" />
                  <ng-template #otherIcons>
                    <img [src]="libHelper?.fileThumbbyName(item)" *ngIf="item?.type !== 'folder'" class="mr-2" width="20" />
                  </ng-template>
                  <span [ngClass]="{ 'f-12': propertyId?.length > 0 }">{{ item?.name }}</span>
                </td>
                <td
                  id="drag-n-drop-main-td"
                  style="padding-left: 5px !important"
                  draggable="false"
                  (dragleave)="onDragLeave($event, item)"
                  (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, item)"
                  (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, item)"
                  (dragend)="onDragEnd()"
                  (drop)="onDrop($event, item)">
                  <span [ngClass]="{ 'f-12': propertyId?.length > 0 }">{{ item.updated_at | date: 'dd MMM yyyy' }}</span>
                </td>
                <td
                  id="drag-n-drop-main-td"
                  style="padding-left: 5px !important"
                  draggable="false"
                  (dragleave)="onDragLeave($event, item)"
                  (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, item)"
                  (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, item)"
                  (dragend)="onDragEnd()"
                  (drop)="onDrop($event, item)">
                  <span [ngClass]="{ 'f-12': propertyId?.length > 0 }">{{ item.readable_file_size ? item.readable_file_size : '-' }}</span>
                </td>
                <td
                  id="drag-n-drop-main-td"
                  style="padding-left: 5px !important"
                  draggable="false"
                  (dragleave)="onDragLeave($event, item)"
                  (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, item)"
                  (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, item)"
                  (dragend)="onDragEnd()"
                  (drop)="onDrop($event, item)">
                  <span [ngClass]="{ 'f-12': propertyId?.length > 0 }">{{ item.created_at | date: 'dd MMM yyyy' }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ng-container>
      </div>
    </section>
    <!-- End Data -->
    <ng-template #notfound>
      <div *ngIf="loading">
        <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
      </div>
      <div
        class="p-5 d-flex align-items-center justify-content-center flex-column notfound"
        id="drag-n-drop-main"
        draggable="true"
        (dragleave)="onDragLeave($event, null)"
        (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, null)"
        (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, null)"
        (dragend)="onDragEnd()"
        (drop)="onDrop($event, null)">
        <h2 class="f-18 font-weight-bold">Nothing found <img class="ml-2" [src]="images?.sad_icon" alt="" /></h2>
        <p class="pt-2 f-12">Please add or upload files / folder</p>
      </div>
    </ng-template>
  </div>
  <!-- End Body -->
</div>

<!-- File upload -->
<input
  [hidden]="true"
  multiple
  id="{{ fileUploadInputId }}"
  type="file"
  (change)="onSelectFile($event)"
  [accept]="innerDefault == 'floorplans' ? '.pdf' : '.png,.jpg,.jpeg,.pdf,.docx,.doc'" />

<!-- Modal 01 -->
<!-- Add Folder Modal -->
<p-dialog
  (keydown.enter)="
    !isWorkspace && category != 'useroffice' && addFolder();
    isWorkspace && createNewWorkspace();
    category == 'useroffice' && addNewFileFolderPrivateFolder('folder')
  "
  [(visible)]="addFolderModal"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '300px', margin: 'auto 0' }">
  <ng-template pTemplate="header">
    <span class="font-weight-500" *ngIf="!isWorkspace"> New folder</span>
    <span class="font-weight-500" *ngIf="isWorkspace"> New workspace</span>
  </ng-template>
  <input
    type="text"
    placeholder="{{ isWorkspace ? 'Workspace name' : 'Folder name' }}"
    required
    #folderName
    (keydown.enter)="$event.preventDefault(); getFolderName(folderName.value)"
    class="mt-3"
    [ngClass]="{ '_input-error': error }" />
  <small class="f-12 text-danger py-1" *ngIf="error">
    {{ error }}
  </small>
  <div class="mt-3 text-right">
    <button type="button" class="_cancel-btn" (click)="addFolderModal = false">Cancel</button>
    <button
      type="button"
      class="_outline-btn mr-0"
      style="margin-right: -5px"
      [disabled]="loading"
      (click)="
        !isWorkspace && category != 'useroffice' && addFolder(); isWorkspace && createNewWorkspace(); category == 'useroffice' && onAddFolderClick()
      "
      autofocus>
      Create
    </button>
  </div>
  <!-- <ng-template pTemplate="footer">
  </ng-template> -->
</p-dialog>

<!-- Modal 02 -->
<!-- Rename FolderFile Modal -->
<p-dialog
  [(visible)]="modalRenameFolderFile"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '300px', margin: 'auto 0' }">
  <ng-template pTemplate="header"> Rename </ng-template>
  <input type="text" required #filefolderRename (keyup)="setRenameFileFolder(filefolderRename?.value)" class="mb-1 mt-3" />
  <small class="f-12 text-danger py-1" *ngIf="error">
    {{ error }}
  </small>
  <ng-template pTemplate="footer">
    <button type="button" class="_cancel-btn" (click)="modalRenameFolderFile = false">Cancel</button>
    <button
      type="button"
      class="mr-0 _outline-btn"
      (click)="
        !isWorkspace && category != 'useroffice' && renameFolderFile();
        isWorkspace && renameWorkspace();
        category == 'useroffice' && renameOfficeLibraryFileFolders()
      "
      autofocus>
      Rename
    </button>
  </ng-template>
</p-dialog>

<!-- Modal 03 -->
<!-- Move FolderFile Modal -->
<p-dialog
  [(visible)]="modalMoveFolder"
  class="workspace-modal"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '300px', margin: 'auto 0' }">
  <ng-template pTemplate="header">
    <span class="font-weight-500" *ngIf="!isAddingInWorkspace">Move to Folder</span>
    <span class="font-weight-500" style="font-size: 14px" *ngIf="isAddingInWorkspace">Add to Workspace</span>
  </ng-template>
  <br />
  <p-tree [value]="cachingFoldersData" (onNodeSelect)="nodeSelect()" selectionMode="single" [(selection)]="selectedNodeToMoveIN"></p-tree>

  <ng-template pTemplate="footer">
    <button type="button" class="_cancel-btn" (click)="modalMoveFolder = false">Cancel</button>
    <button
      type="button"
      [disabled]="cachingFoldersData?.length == 0"
      class="_outline-btn"
      (click)="!isAddingInWorkspace && moveFolderFile(); isAddingInWorkspace && addItemIntoWorkspace()"
      autofocus>
      {{ isAddingInWorkspace ? 'Add' : 'Move' }}
    </button>
  </ng-template>
</p-dialog>

<!-- Modal 04 -->
<!-- Modal Get Link -->
<p-dialog
  [(visible)]="modalGetLink"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px', margin: 'auto 0' }">
  <ng-template pTemplate="header"> Get Link </ng-template>
  <div class="modalGetLink mt-3">
    <div class="modalGetLink-header d-flex align-items-center">
      <span class="mgl-thumb mr-3">
        <img [src]="images?.link_light_icon" alt="" width="20" />
      </span>
      <span class="mgl-content"> Get Link </span>
    </div>
    <div class="modalGetLink-body pt-4">
      <div class="form-group mb-4">
        <input type="text" required #getLinkField readonly />
      </div>
      <div class="mt-3 text-right">
        <button class="_cancel-btn" (click)="copyToClipboard()">Copy Link</button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Modal Get Path -->
<p-dialog
  [(visible)]="ModalGetPath"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px', margin: 'auto 0' }">
  <ng-template pTemplate="header"> Get Path </ng-template>
  <div class="modalGetLink mt-3">
    <div class="modalGetLink-header d-flex align-items-center">
      <span class="mgl-thumb mr-3">
        <i class="pi pi-directions f-18 text-white"></i>
      </span>
      <span class="mgl-content"> Get Path </span>
    </div>
    <div class="modalGetLink-body pt-4">
      <div class="form-group mb-4">
        <input type="text" required #getLinkPath readonly />
      </div>
      <div class="text-right mt-3 mb-1">
        <a class="_cancel-btn cursor-pointer" (click)="ModalGetPath = false">Close</a>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Modal 05 -->
<!-- Modal Preview -->
<p-dialog
  header="File Preview"
  [(visible)]="modalPreview"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [class.image-viewer]="fileImagePWLink?.length > 0">
  <div class="position-relative w-100 mt-3">
    <!-- <div *ngIf="filePWLink">
      <ngx-doc-viewer [url]="filePWLink" viewer="google"
        style="width: 100%; height: 93.5vh; object-fit: cover"></ngx-doc-viewer>
    </div> -->
    <div class="{{ mobToggle ? 'mobile-img-gallery-preview' : 'img-gallery-preview' }}">
      <div class="divShadow p-0 position-relative">
        <ng-container *ngIf="!isImagePreviewLoading && fileImagePWLink">
          <img [src]="fileImagePWLink" alt="" class="main-images" />
        </ng-container>
        <ng-template>
          <div class="elsePart">
            <img [src]="common_images?.image_not_found" class="no-images" />
          </div>
        </ng-template>
      </div>
    </div>
    <div class="asd" style="height: 80%" *ngIf="fileEmbedVideoURL" [innerHtml]="fileEmbedVideoURL | safeHtml: 'html'"></div>
  </div>
</p-dialog>

<!-- Modal Workspace -->
<div class="modalPreview">
  <p-dialog
    [(visible)]="isWorkspaceModalOpened"
    [dismissableMask]="true"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '600px', margin: 'auto 0' }">
    <ng-template pTemplate="header">
      {{ workspaceDetailedData?.name }}
    </ng-template>
    <div class="mt-3">
      <p-table [value]="workspaceDetailedData?.files_or_folders" [scrollable]="true" scrollHeight="60vh" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th class="f-14" style="padding-left: 20px">Name</th>
            <th class="f-14" style="padding-left: 20px">Last Modified</th>
            <th class="f-14" style="padding-left: 20px">File Size</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-i="rowIndex">
          <!-- Files -->
          <tr
            (dblclick)="item.type === 'folder' ? selectFolders(item) : showModalPreview(item)"
            (contextmenu)="filesOptions.show($event); rightClickHandler($event, item)">
            <td
              class="pl-0 text-truncate"
              pTooltip="{{ getFolderFileInformationTooltipHandler(item) }}"
              [tooltipDisabled]="isTooltipDisabled"
              [escape]="false"
              tooltipPosition="bottom">
              <img *ngIf="item.type === 'folder' && item?.childrens?.length === 0" [src]="images?.lib_folder_icon" class="mr-2" width="20" />
              <img *ngIf="item.type === 'folder' && item?.childrens?.length > 0" [src]="images?.lib_filled_folder_icon" class="mr-2" width="20" />
              <img
                *ngIf="
                  (item?.type !== 'folder' && item?.file_type === 'image/jpeg') ||
                    item?.file_type === 'image/png' ||
                    item?.file_type === 'image/jpeg';
                  else otherIcons
                "
                [src]="getCompressImageByPath(item)"
                (error)="LoadImageonError($event, item)"
                class="mr-2"
                width="20" />
              <ng-template #otherIcons>
                <img [src]="libHelper?.fileThumbbyName(item)" *ngIf="item?.type !== 'folder'" class="mr-2" width="20" />
              </ng-template>
              {{ item?.name }}
            </td>
            <td>{{ item?.created_at | date: 'dd MMM yyyy' }}</td>
            <td>{{ item?.readable_file_size ? item.readable_file_size : '-' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template pTemplate="footer">
      <button type="button" class="_outline-btn" (click)="isWorkspaceModalOpened = false">Close</button>
    </ng-template>
  </p-dialog>
</div>

<!-- Modal Share with Users -->
<p-dialog
  [(visible)]="modalShare"
  [dismissableMask]="true"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px', margin: 'auto 0' }">
  <ng-template pTemplate="header"> Share with people </ng-template>
  <div class="modalGetLink mt-3">
    <div class="modalGetLink-header d-flex align-items-center">
      <span class="mgl-thumb mgl-thumb-primary mr-3">
        <img [src]="images?.share_bg_icon" alt="" width="50" class="share-image" />
      </span>
      <span class="mgl-content">
        Add people or teams
        <ng-container *ngIf="sharedItems && sharedItems?.length > 1; else singleItem">
          <p class="f-12 pt-2">
            <span class="font-weight-500">{{ sharedItems?.length }}</span> Files shared
          </p>
        </ng-container>
        <ng-template #singleItem>
          <p class="f-12 pt-2">
            <span class="font-weight-500" *ngIf="sharedItems && sharedItems?.length">{{ sharedItems[0]?.name || '' }}</span>
          </p>
        </ng-template>
      </span>
    </div>
    <div class="modalGetLink-body pt-4 w-100">
      <div class="form-group d-flex w-100 align-items-start share-auto">
        <ng-select
          [(ngModel)]="selectedUsersToShare"
          [items]="isInternal ? internal : allUsers"
          bindLabel="full_name"
          class="w-100"
          [searchable]="true"
          placeholder="Search User"
          [clearable]="true"
          [multiple]="true"
          [ngModelOptions]="{ standalone: true }"></ng-select>
        <!-- <p-autoComplete
          *ngIf="modalShare"
          #userautocomplete
          [(ngModel)]="selectedUsersToShare"
          (onSelect)="onSelectUsers()"
          [suggestions]="filteredUsers"
          (completeMethod)="filterUsers($event)"
          field="email"
          (keydown.enter)="category != 'useroffice' && onSearchSubmit($event)"
          [multiple]="true"
          placeholder="Add people e.g">
          <ng-template let-filteredUsers pTemplate="item">
            <div class="ui-helper-clearfix" *ngIf="!filteredUsers?.office; else notfoundUser">
              <p class="text-dark">{{ filteredUsers?.full_name }}</p>
              <p>
                <small>{{ filteredUsers?.email }}</small>
              </p>
            </div>
            <ng-template #notfoundUser>
              <div class="ui-helper-clearfix">
                <p class="text-dark">{{ filteredUsers?.name }}</p>
                <p><small>Team</small></p>
              </div>
            </ng-template>
          </ng-template>
        </p-autoComplete> -->
      </div>
      <p class="text-danger" *ngIf="!selectedUsersToShare?.length">At least one staff or team must be selected</p>
      <div *ngIf="selectedUsersToShare?.length" [class.overflow-auto]="selectedUsersToShare?.length > 3" style="max-height: 200px">
        <div
          *ngFor="let item of selectedUsersToShare; let i = index; trackBy: trackById"
          [class.mb-3]="selectedUsersToShare?.length == i + 1"
          class="selectedToShare d-flex align-items-center m-2">
          <div *ngIf="item?.photo || item?.face_photo">
            <p-avatar
              styleClass="mr-3"
              size="large"
              image="{{ item?.photo ? S3Path + item.photo : item?.face_photo ? S3Path + item.face_photo : null }}"
              shape="circle"></p-avatar>
          </div>
          <div *ngIf="!item?.photo && !item?.face_photo">
            <p-avatar
              styleClass="mr-3"
              size="large"
              label="{{ getAvatarLabel(item) }}"
              [style]="{ 'background-color': '#e9f4f1', color: '#229276' }"
              shape="circle"></p-avatar>
          </div>
          <div class="d-flex w-100 justify-content-between">
            <div *ngIf="!item?.office; else notfoundUserList">
              <p class="text-dark">{{ item?.full_name }}</p>
              <p>{{ item?.email }}</p>
            </div>
            <ng-template #notfoundUserList>
              <div>
                <p class="text-dark">{{ item?.name }}</p>
                <p>Team</p>
              </div>
            </ng-template>
            <div class="col-md-3 p-0">
              <p-dropdown
                class="share-dropdown"
                [baseZIndex]="999"
                [disabled]="item?.is_disabled"
                [options]="propertyId?.length > 0 || category == 'useroffice' ? sharePermissionOfficeLibrary : sharePermission"
                (onFocus)="rememberPermission(item)"
                (onChange)="onChangeUserPermission($event, item)"
                [(ngModel)]="item.manage"
                optionLabel="name"
                optionValue="value">
                <ng-template let-premissions pTemplate="item" style="border: 1px solid black">
                  <div class="flex align-items-center">
                    <span>{{ premissions?.name }}</span>
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right mt-3 mb-3">
      <button type="button" class="_cancel-btn" (click)="modalShare = false">Cancel</button>
      <button
        type="button"
        class="_outline-btn mr-0"
        (click)="category != 'useroffice' && shareFolderFile(); category == 'useroffice' && shareOfficeLibraryFolderFile()"
        [disabled]="selectedUsersToShare.length <= 0 || isPending"
        autofocus>
        Share
      </button>
    </div>
  </div>
</p-dialog>
<p-toast position="bottom-center" [preventOpenDuplicates]="true"> </p-toast>

<div *ngIf="noSideBar == false" class="right-bar d-flex align-items-start" [class.show-rightbar]="showRightBar">
  <div class="d-flex align-items-start inner-wrap w-40">
    <div class="site-card mr-2 actions text-center">
      <div class="mb-1">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-times"
          (click)="closeRightBar()"
          class="p-button-rounded p-button-secondary p-button-text"></button>
      </div>
    </div>
    <div class="site-card table-rightbar p-4">
      <ng-container>
        <div class="form-group">
          <ng-select
            class="ng-site-input"
            (change)="getSelectedDirectory($event)"
            [items]="directoryList"
            bindLabel="name"
            bindValue="value"
            [(ngModel)]="selectedDirectory"
            [searchable]="true"
            [multiple]="false"
            placeholder="Select Directory">
          </ng-select>
        </div>
      </ng-container>

      <ng-container *ngIf="directoryListData?.length > 0">
        <p-treeTable
          [value]="directoryListData"
          class="tree-datalist"
          [scrollable]="true"
          scrollHeight="60vh"
          [loading]="loading"
          selectionMode="single"
          [(selection)]="selectedNode"
          dataKey="_id">
          <ng-template pTemplate="header">
            <tr>
              <th class="f-14">Name</th>
              <th class="f-14">Size</th>
              <th class="text-center f-14" style="width: 100px">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
              <td class="text-ellipsis small">
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                {{ rowData?.name }}
              </td>
              <td class="small">{{ rowData?.size ? rowData?.size : '-' }}</td>
              <td class="text-center small" style="width: 100px">
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-plus"
                  styleClass="p-button-sm"
                  title="Add to Workspace"
                  (click)="addToWorkspace(rowNode?.node)"
                  class="p-button-primary"></button>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </ng-container>
    </div>
  </div>
</div>

<p-overlayPanel
  #filesOptions
  [baseZIndex]="99999"
  [ngStyle]="{ visibility: contextmenuY > 0 ? 'visible' : 'hidden' }"
  id="filesOpt"
  (onShow)="resetOverlayPanel($event, 'fileOP'); isTooltipDisabled = true"
  (onHide)="isTooltipDisabled = false">
  <ng-template pTemplate>
    <ng-container *ngIf="selectedContextMenuItem?.ispermission == true; else no_permission">
      <div class="body-details border-0 p-0 bg-white" id="folderOptionsList">
        <ul class="folders">
          <div *ngIf="page_title != 'Trash Files'">
            <li *ngIf="page_title == 'My Workspace' && selectedContextMenuItem?.files_or_folders">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'add-files')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'add-files')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-plus f-12 text-dark mr-3"></i> Add Files
              </a>
            </li>
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'preview')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'preview')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-eye f-12 text-dark mr-3"></i> Preview
              </a>
            </li>
            <li *ngIf="page_title != 'Shared with me' && !selectedContextMenuItem?.files_or_folders">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'share')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'share')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-user-plus f-12 text-dark mr-3"></i> Share
              </a>
            </li>
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'link')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'link')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-link f-12 text-dark mr-3"></i> Get Link
              </a>
            </li>
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'path')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'path')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-directions f-12 text-dark mr-3"></i> Get Path
              </a>
            </li>
            <li *ngIf="page_title != 'My Workspace' && category != 'useroffice' && category !== 'favourite'">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'move-to-folder')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'move-to-folder')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-cloud-upload f-12 text-dark mr-3"></i> Move to
              </a>
            </li>
            <li
              *ngIf="
                library_type != 'office' &&
                page_title != 'Trash Files' &&
                (category == 'folder' || category == 'workspace' || category == 'recent' || category == 'useroffice')
              ">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'workspace')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'workspace')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <img [src]="images?.brief_case_icon" alt="Rename" class="mr-3" width="13px" height="13px" /> Add to Workspace
              </a>
            </li>
            <li *ngIf="!isFavourite && !selectedContextMenuItem?.files_or_folders && category != 'useroffice'">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'add-to-favourite')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'add-to-favourite')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-star f-12 text-dark mr-3"></i> Add to Favourites
              </a>
            </li>
            <li *ngIf="isFavourite">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'remove-from-favourite')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'remove-from-favourite')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-star f-12 text-dark mr-3"></i> Remove from Favourites
              </a>
            </li>
            <li>
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'rename')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'rename')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <img [src]="common_images?.edit_icon" alt="Rename" class="mr-3" width="13px" height="13px" /> Rename
              </a>
            </li>
            <!-- <li
              *ngIf="isFile && selectedContextMenuItem?.file_type?.includes('image') && !selectedContextMenuItem?.slider_images?.length">
              <a (click)="filesOptions.hide(); selectedContextMenuItem.isSlider = !selectedContextMenuItem?.isSlider; contextMenuHandler($event, 'create-slider')"
                (contextmenu)="filesOptions.hide(); selectedContextMenuItem.isSlider = !selectedContextMenuItem?.isSlider; contextMenuHandler($event, 'create-slider')"
                href="javascript:void(0)" class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-eye f-12 text-dark mr-3"></i> Create Slider
              </a>
            </li>
            <li
              *ngIf="isFile && selectedContextMenuItem?.file_type?.includes('image') && selectedContextMenuItem?.slider_images?.length > 0">
              <a (click)="filesOptions.hide(); contextMenuHandler($event, 'remove-slider')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'remove-slider')"
                href="javascript:void(0)" class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-eye f-12 text-dark mr-3"></i> Remove Slider
              </a>
            </li> -->

            <li *ngIf="page_title != 'My Workspace'">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'copy')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'copy')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-copy f-12 text-dark mr-3"></i> Make a Copy
              </a>
            </li>
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'download')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'download')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-download f-12 text-dark mr-3"></i> Download
              </a>
            </li>
            <li *ngIf="page_title == 'My Workspace' && selectedContextMenuItem?.files_or_folders">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'hide-workspace')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'hide-workspace')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-exclamation-triangle f-12 text-dark mr-3"></i> Hide Workspace
              </a>
            </li>
            <li *ngIf="!recentClickedContextMenu">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'remove')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'remove')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <img [src]="common_images?.delete_icon" alt="Remove" class="mr-3" width="14px" />Remove
              </a>
            </li>
          </div>
          <ng-container *ngIf="page_title == 'Trash Files'">
            <li>
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'restore')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'restore')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-replay f-12 text-dark mr-3"></i> Restore
              </a>
            </li>
            <li>
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'delete-forever')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'delete-forever')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <img [src]="common_images?.delete_icon" alt="Remove" class="mr-3" width="14px" /> Delete forever
              </a>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <ng-template #no_permission>
      <div class="body-details border-0 p-0 bg-white" id="folderOptionsList">
        <ul class="folders">
          <div *ngIf="page_title != 'Trash Files'">
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'preview')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'preview')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-eye f-12 text-dark mr-3"></i> Preview
              </a>
            </li>
            <li *ngIf="isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'download')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'download')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-download f-12 text-dark mr-3"></i> Download
              </a>
            </li>
          </div>
          <div *ngIf="page_title == 'My Workspace'">
            <li *ngIf="!isFile">
              <a
                (click)="filesOptions.hide(); contextMenuHandler($event, 'hide-workspace')"
                (contextmenu)="filesOptions.hide(); contextMenuHandler($event, 'hide-workspace')"
                href="javascript:void(0)"
                class="d-flex align-items-center f-14 text-dark px-2 py-2">
                <i class="pi pi-exclamation-triangle f-12 text-dark mr-3"></i> Hide Workspace
              </a>
            </li>
          </div>
        </ul>
      </div>
    </ng-template>
  </ng-template>
</p-overlayPanel>

<div class="lib-overlay-bg" *ngIf="libEdit">
  <div class="lib-edit">
    <div class="lib-main">
      <div class="lib-head">
        <div class="{{ mobToggle ? 'd-block mt-7' : 'd-flex' }}">
          <div class="d-flex">
            <a class="mr-2 mt-1" href="javascript:void(0)" (click)="showLibedit(); lmService.showIcons = true"
              ><img [src]="common_images?.group_icon"
            /></a>
            <div>
              <div class="d-flex">
                <div class="lib-bg lib-border zoom-box" style="width: 259px !important">
                  <p-slider [Change]="gridSliderUpdated()" [(ngModel)]="gridpercentage" class="mr-3 g-slider"></p-slider>
                  <span class="f-16">{{ gridpercentage }}%</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ml-auto d-flex {{ mobToggle ? 'mt-2' : '' }}"
            style="margin-top: -4px"
            [ngStyle]="{ 'pointer-events': dragEditLoading ? 'none' : 'auto', opacity: dragEditLoading ? '0.5' : '1' }">
            <div class="lib-bg lib-border mr-2" *ngIf="selectedGallaryItem?.orignal_path && selectedGallaryItem?.edited == true">
              <div class="nav-btn">
                <a
                  href="javascript:void(0)"
                  tooltipStyleClass="customTip"
                  [escape]="false"
                  pTooltip="{{ restoreTip() }}"
                  tooltipPosition="bottom"
                  (click)="restoreToOrignalImage()"
                  ><img class="mt--3" [src]="images?.restore_icon"
                /></a>
              </div>
            </div>
            <div class="lib-bg lib-border">
              <div class="nav-btn mr-2">
                <a
                  style="height: 15px; display: block"
                  href="javascript:void(0)"
                  tooltipStyleClass="customTip"
                  [escape]="false"
                  pTooltip="PDF to image"
                  tooltipPosition="bottom"
                  (click)="triggerPdffile(); pdfPagesOverlay.toggle($event)"
                  ><i class="pi pi-file-pdf mt--3" style="font-size: 23px !important"></i
                ></a>
                <input
                  #pdffile
                  id="pdffile"
                  class="d-none"
                  [hidden]="true"
                  type="file"
                  (click)="$event.target.value = null"
                  (change)="convertPDF($event, $event.target.files)"
                  accept=".pdf" />
              </div>
              <div class="nav-btn mr-2">
                <a
                  style="height: 15px; display: block"
                  href="javascript:void(0)"
                  tooltipStyleClass="customTip"
                  [escape]="false"
                  pTooltip="Image upload"
                  tooltipPosition="bottom"
                  (click)="triggerFileUpload()"
                  ><i class="pi pi-cloud-upload mt--3" style="font-size: 23px !important"></i
                ></a>
              </div>
              <div class="nav-btn mr-2">
                <a
                  href="javascript:void(0)"
                  tooltipStyleClass="customTip"
                  [escape]="false"
                  tooltipPosition="bottom"
                  pTooltip="Delete selected images"
                  (click)="checkFileAccess(this.selectedGalItems, 'remove')">
                  <img class="mt--3" style="width: 24px" [src]="common_images?.delete_icon"
                /></a>
              </div>
              <div class="nav-btn mr-1">
                <a
                  href="javascript:void(0)"
                  tooltipStyleClass="customTip"
                  [escape]="false"
                  pTooltip="Duplicate selected image"
                  tooltipPosition="bottom"
                  (click)="checkFileAccess(this.selectedGalItems, 'popup-editor-duplicate')"
                  ><img class="mt--3" [src]="images?.copy_icon" style="width: 28px"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lib-body lib-bg lib-border">
        <p-progressSpinner class="editor-loader" [style]="{ width: '50px', height: '50px' }" *ngIf="dragEditLoading"></p-progressSpinner>
        <div [ngStyle]="{ 'pointer-events': dragEditLoading ? 'none' : 'auto', opacity: dragEditLoading ? '0.5' : '1' }">
          <p-splitter [panelSizes]="[100, 0]" [style]="{ height: '72vh', width: '100%' }" styleClass="mb-5">
            <ng-template pTemplate>
              <div
                id="drag-n-drop-edit"
                class="d-block"
                style="width: 100%"
                draggable="true"
                (dragleave)="onDragLeave($event, null)"
                (dragstart)="!isDragDropSorting && isDraggableFeature && onDragStart($event, null)"
                (dragover)="!isDragDropSorting && isDraggableFeature && onDragOver($event, null)"
                (dragend)="onDragEnd()"
                (drop)="onDrop($event, null)"
                cdkDropListGroup>
                <div
                  style="height: auto; min-width: 100px; overflow: auto; max-height: 44vh"
                  [ngStyle]="{ 'min-height': isAccord ? '44vh' : '65vh' }">
                  <h2 class="mb-3 heading-style" style="font-size: 12px !important; font-weight: 500 !important; padding-left: 3px">
                    Drag and drop images to reorder, changes will auto save.
                  </h2>
                  <a
                    class="d-flex align-items-center text-dark f-14 font-weight-bold pr-3 my-2"
                    href="javascript:void(0);"
                    (click)="selectFolders(breadcrumbItems[breadcrumbItems?.length - 2]?.url)"
                    *ngIf="
                      editorBackBtn && breadcrumbItems?.length > backBtnValue && breadcrumbItems[breadcrumbItems?.length - 1]?.label === 'Floorplans'
                    ">
                    <i class="fa fa-arrow-left mr-2"></i>Back
                  </a>
                  <div #dropListContainer class="gal-thumb-container">
                    <div
                      class="the-dropList-item"
                      *ngIf="galItems?.length === 0"
                      style="min-height: 20vh; min-width: 1000px"
                      cdkDropList
                      [cdkDropListData]="{ itm: item, index: i }"
                      #galImgList="cdkDropList"
                      (cdkDropListDropped)="drop($event)"
                      [cdkDropListConnectedTo]="[portalImgList]"></div>
                    <div
                      class="the-dropList-item"
                      id="galImgList"
                      *ngFor="let item of galItems | searchFilter: searchKeyword; let i = index; trackBy: trackById"
                      cdkDropList
                      [cdkDropListData]="{ itm: item, index: i }"
                      #galImgList="cdkDropList"
                      style="display: flex"
                      (cdkDropListDropped)="drop($event)"
                      [cdkDropListConnectedTo]="[portalImgList]">
                      <div (mousedown)="mouseDown($event, item)" cdkDrag class="gal-thumb-box position-relative mb-3">
                        <a
                          class="hwfix"
                          href="javascript:void(0)"
                          (click)="selectGallaryItem(item, getLargeImageByPath(item), $event)"
                          *ngIf="
                            (item?.type !== 'folder' && item?.file_type === 'image/jpeg') ||
                              item?.file_type === 'image/png' ||
                              item?.file_type === 'image/jpeg';
                            else otherIcons
                          ">
                          <div class="img-hub-center" [style]="{ width: gridthumbwidth + 'px', height: gridthumbheight + 'px' }">
                            <div class="editMarkDiv" *ngIf="item?.edited">
                              <div class="edit-mark"><i class="pi pi-pencil"></i></div>
                            </div>
                            <div class="img-hub {{ selectedGalItems_ids.includes(item._id) ? 'img-hub_selected' : '' }}">
                              <img [src]="getCompressImageByPath(item)" class="img-hub2" (error)="LoadImageonError($event, item)" />
                              <img [src]="common_images?.lock_icon" class="private-editor-icon" *ngIf="item?.private_file_access" />
                            </div>
                          </div>
                        </a>
                        <div
                          class="position-relative d-flex align-items-center justify-content-center"
                          [style]="{ width: gridthumbwidth + 'px', height: gridthumbheight + 'px' }"
                          (dblclick)="
                            page_title != 'My Workspace' && category != 'trash' && item?.type === 'folder'
                              ? selectFolders(item, false)
                              : checkPublicPrivate(item)
                          "
                          style="box-shadow: 0 0 2px #ccc; border-radius: 8px; cursor: pointer; margin: 4px 6px 0px 6px"
                          *ngIf="item?.type === 'folder' && item?.name === 'Floorplans' && page_title != 'My Workspace'">
                          <img
                            [id]="item?._id"
                            *ngIf="item?.childrens.length === 0"
                            [src]="images?.lib_folder_icon"
                            [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                            class="file-image" />
                          <img
                            [id]="item?._id"
                            *ngIf="item?.childrens.length > 0"
                            [src]="images?.lib_filled_folder_icon"
                            [ngClass]="{ 'h-4rem': propertyId?.length > 0 }"
                            class="file-image" />

                          <p
                            [id]="item?._id"
                            class="folder_text text-ellipsis mt-2 black-text"
                            (click)="page_title == 'My Workspace' && openWorkspaceModal(item)"
                            [ngClass]="{ 'w-75': page_title == 'My Workspace', 'f-12': propertyId?.length > 0 }">
                            {{ item?.name }}
                          </p>
                        </div>
                        <p
                          [id]="item?._id"
                          class="img-txt"
                          *ngIf="item?.type !== 'folder' && item?.name !== 'Floorplans' && page_title != 'My Workspace'"
                          (click)="page_title == 'My Workspace' && openWorkspaceModal(item)"
                          [ngClass]="{ 'w-75': page_title == 'My Workspace', 'f-12': propertyId?.length > 0 }">
                          {{ item?.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <div class="m-2 mt-0 cursor-pointer" (click)="isAccord = !isAccord">
                    <h2 class="mb-1 heading-style" style="font-size: 16px !important; font-weight: 500">
                      {{ 'Offline Images' }}
                    </h2>
                    <h4 style="font-size: 11px !important; font-weight: 500 !important">
                      {{ 'Click to expand and drag and drop images you do not want to push to portals.' }}
                    </h4>
                  </div>
                  <div
                    id="portalImgList"
                    class="gal-thumb-container"
                    style="height: 20vh; overflow: auto"
                    [ngStyle]="{ 'min-height': isAccord ? '15vh' : '1vh' }"
                    (dragover)="onDragOver($event, null)"
                    (drop)="onDrop($event, null)">
                    <ng-container *ngIf="isAccord">
                      <div
                        class="the-dropList-item"
                        id="portalImgList"
                        [ngStyle]="calculatePadding(portalImages.length, isLast)"
                        *ngFor="let item of portalImages | searchFilter: searchKeyword; let i = index; last as isLast; trackBy: trackById"
                        cdkDropList
                        [cdkDropListData]="{ itm: item, index: i }"
                        #portalImgList="cdkDropList"
                        style="display: flex"
                        (cdkDropListDropped)="drop($event)"
                        [cdkDropListConnectedTo]="[galImgList]">
                        <div (mousedown)="mouseDown($event, item)" cdkDrag class="gal-thumb-box">
                          <a
                            class="hwfix"
                            href="javascript:void(0)"
                            (click)="selectGallaryItem(item, getLargeImageByPath(item), $event)"
                            *ngIf="
                              (item?.type !== 'folder' && item?.file_type === 'image/jpeg') ||
                                item?.file_type === 'image/png' ||
                                item?.file_type === 'image/jpeg';
                              else otherIcons
                            ">
                            <div class="img-hub-center" [style]="{ width: gridthumbwidth + 'px', height: gridthumbheight + 'px' }">
                              <div class="editMarkDiv" *ngIf="item?.edited">
                                <div class="edit-mark"><i class="pi pi-pencil"></i></div>
                              </div>
                              <div class="img-hub {{ selectedGalItems_ids.includes(item._id) ? 'img-hub_selected' : '' }}">
                                <img [src]="getCompressImageByPath(item)" class="img-hub2" (error)="LoadImageonError($event, item)" />
                                <img [src]="common_images?.lock_icon" class="private-editor-icon" *ngIf="item?.private_file_access" />
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div
                        class="the-dropList-item"
                        *ngIf="portalImages.length === 0"
                        style="min-height: 2vh; min-width: 1000px"
                        cdkDropList
                        [cdkDropListData]="{ itm: item, index: i }"
                        #portalImgList="cdkDropList"
                        (cdkDropListDropped)="drop($event)"
                        [cdkDropListConnectedTo]="[galImgList]"></div>
                    </ng-container>
                  </div>
                </div>
              </div>

              <div>
                <div id="preview" class="preview">
                  <table>
                    <tr>
                      <td>
                        <p>File Name</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.name }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Location</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p style="text-transform: capitalize">{{ overIt?.item_category }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Sized</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.readable_file_size }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Type</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.file_type }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Uploaded by</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.info_div?.uploadedby }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Modified</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.info_div?.modified }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Date uploaded</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.info_div?.created }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Dimensions</p>
                      </td>
                      <td>&nbsp;&nbsp;&nbsp;</td>
                      <td>
                        <p>{{ overIt?.dimentions }}</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </ng-template>
          </p-splitter>
        </div>
        <a style="color: black" *ngIf="!reNaming" href="javascript:void(0)" (click)="reNaming = true; reNameTo = selectedGallaryItem?.name">
          <div class="filename">{{ selectedGallaryItem?.name }}</div>
        </a>
        <div *ngIf="reNaming" class="filename" style="z-index: 9; position: relative"></div>
      </div>
    </div>
  </div>
</div>
<app-file-uploading-status-box
  [filesProgress]="filesUploadingStatus.asObservable()"
  (fileCancelUpload)="cancelFile($event)"></app-file-uploading-status-box>

<p-overlayPanel #pdfPagesOverlay>
  <ng-template pTemplate="content">
    <div class="d-flex" *ngIf="pdfConverting">
      <p-progressSpinner class="ml-auto mr-auto" [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    </div>
    <div class="d-flex flex-wrap w-100 gap-2" *ngIf="pdfPages.length > 0">
      <a href="javascript:void(0)" *ngFor="let page of pdfPages" (click)="uploadSelectPdfPage(page)">
        <img src="{{ page }}" class="pp-thumb" alt="" />
      </a>
    </div>
  </ng-template>
</p-overlayPanel>

<p-dialog
  header="File Access"
  [showHeader]="true"
  [(visible)]="file_access"
  [draggable]="false"
  [style]="{ width: '20vw' }"
  [modal]="true"
  [baseZIndex]="100000">
  <div class="w-100 mt-3">
    <input type="number" class="site-input" [(ngModel)]="file_access_pin" placeholder="PIN" />
  </div>
  <div class="text-right my-2">
    <button class="_cancel-btn" (click)="file_access = false; file_access_pin = null">Cancel</button>
    <button class="_outline-btn" (click)="checkPin()">Save</button>
  </div>
</p-dialog>

<!-- <app-sp-slider *ngIf="selectedContextMenuItem.isSlider" [isDialogOnly]="true"
  (onLoadImages)="onLoadSliderImages($event)"></app-sp-slider> -->
